import { DEFAULT_NOTIFICATIONS_PAGE_SIZE } from "@/core/utils/constants";
//BASE APIS
const baseAnnualReportServi = "/annual-report-servi";
const classificationServi = "/jurisdiccional-servi";
//ANNUALREPORT APIS

// Quejas
const baseComplaints = "/queja";

// Gestión de solicitudes de Soporte técnico - base url.
const baseUserTS = "/technical-support";
const baseUserTSDownLoad = "/documentfile-url";

// Histórico de consumidores financieros - base url.
const baseHistoricalConsum = "/userhistorycf";

const updateAnualReport = (id) =>
  `${baseAnnualReportServi}/update_report?id=${id}`;
const getCounters = (query) => `${baseAnnualReportServi}/get_counters${query}`;
const createAnualReport = `${baseAnnualReportServi}/create_report`;
const getAnualReport = (id) => `${baseAnnualReportServi}/get_report?id=${id}`;
const listAnualReports = (query) =>
  `${baseAnnualReportServi}/list_reports${query}`;
const updateAnualReportFiles = `/queries-servi/file/annual_report_attach`;

const deleteAnualReportFiles = `/queries-servi/file/delete_dcf_attach`;

// Reportes
const getReports = () => `${baseAnnualReportServi}/list_ev_reports`;
const multifilterReport = (data) =>
  `${baseAnnualReportServi}/list_ev_reports?responsable=${data.responsable}&state=${data.state}&filter_date=${data.filter_date}&entity_id=${data.entity_id}&start_date=${data.start_date}&end_date=${data.end_date}`;
const getReport = (id) => `${baseAnnualReportServi}/get_report_ev?id=${id}`;
const manageReport = (id) =>
  `${baseAnnualReportServi}/upload_ev_report?doc_id=${id}`;

const uploadFIlesReport = (id) =>
  `${baseAnnualReportServi}/upload_ev_attach?document_id=${id}`;

// Clasificación
const getClassifition = () =>
  `${classificationServi}/right-request-classification`;

const getClassifitionBySearching = (data) =>
  `${classificationServi}/right-request-classification?page=${
    data.page
  }&page_size=${data.page_size}&tipo_entidad=${
    data.tipo_entidad || ""
  }&producto_cod=${data.producto_cod || ""}&macro_motivo_cod=${
    data.macro_motivo_cod || ""
  }&codigo_queja=${data.codigo_queja || ""}&insta_recepcion=${
    data.insta_recepcion || ""
  }&start_date=${data.start_date || ""}&end_date=${
    data.end_date || ""
  }&tipo_id_cf=${data.tipo_id_cf || ""}&nombre_cf=${
    data.nombre_cf || ""
  }&apoderado_nombre=${data.apoderado_nombre || ""}&email_user=${
    data.email_user || ""
  }&check_habeas_data=${
    data.check_habeas_data === true || data.check_habeas_data === false
      ? data.check_habeas_data
      : ""
  }&search=${data.search || ""}&company_sfc_code=${
    data.company_sfc_code || ""
  }&tipo_analisis=${data.tipo_analisis || ""}&is_derecho_peticion_usuario=${
    data.is_derecho_peticion_usuario || ""
  }&numero_id_cf=${data.numero_id_cf || ""}&email_notification_user=${
    data.email_notification || ""
  }`;

const getRetrieveUserCompressions = () =>
  `${classificationServi}/retrieve-user-compressions`;

const cancelCompressJob = () => {
  return `${classificationServi}/cancel-compress-job`;
};

const getRetrieveAnnexes = (data) =>
  `${classificationServi}/retrieve-annexes?tipo_entidad=${
    data.tipo_entidad || ""
  }&producto_cod=${data.producto_cod || ""}&macro_motivo_cod=${
    data.macro_motivo_cod || ""
  }&codigo_queja=${data.codigo_queja || ""}&insta_recepcion=${
    data.insta_recepcion || ""
  }&start_date=${data.start_date || ""}&end_date=${
    data.end_date || ""
  }&tipo_id_cf=${data.tipo_id_cf || ""}&nombre_cf=${
    data.nombre_cf || ""
  }&apoderado_nombre=${data.apoderado_nombre || ""}&email_user=${
    data.email_user || ""
  }&check_habeas_data=${
    data.check_habeas_data === true || data.check_habeas_data === false
      ? data.check_habeas_data
      : ""
  }&search=${data.search || ""}&company_sfc_code=${
    data.company_sfc_code || ""
  }&tipo_analisis=${data.tipo_analisis || ""}&is_derecho_peticion_usuario=${
    data.is_derecho_peticion_usuario || ""
  }&numero_id_cf=${data.numero_id_cf || ""}&email_notification_user=${
    data.email_notification || ""
  }&classification_type=${data.classification_type || ""}${
    data.complaint_doc_id ? `&complaint_doc_id=${data.complaint_doc_id}` : ""
  }&download_file_type=${data.download_file_type || ""}`;

const getReportClassition = (data) =>
  `${classificationServi}/generate_class_reports?tipo_entidad=${
    data.tipo_entidad || ""
  }&producto_cod=${data.producto_cod || ""}&macro_motivo_cod=${
    data.macro_motivo_cod || ""
  }&codigo_queja=${data.codigo_queja || ""}&insta_recepcion=${
    data.insta_recepcion || ""
  }&start_date=${data.start_date || ""}&end_date=${
    data.end_date || ""
  }&tipo_id_cf=${data.tipo_id_cf || ""}&nombre_cf=${
    data.nombre_cf || ""
  }&apoderado_nombre=${data.apoderado_nombre || ""}&email_user=${
    data.email_user || ""
  }&check_habeas_data=${
    data.check_habeas_data === true || data.check_habeas_data === false
      ? data.check_habeas_data
      : ""
  }&search=${data.search || ""}&company_sfc_code=${
    data.company_sfc_code || ""
  }&numero_id_cf=${data.numero_id_cf || ""}&class_type=${
    data.class_type || ""
  }&tipo_analisis=${data.tipo_analisis || ""}&is_derecho_peticion_usuario=${
    data.is_derecho_peticion_usuario || ""
  }&is_habeas_data_usuario=${data.is_habeas_data_usuario || ""}&get_file=${
    data.get_file || ""
  }&email_notification_user=${data.email_notification || ""}`;

// Habeas data.
const getHabeasData = () => `${classificationServi}/habeas-data-classification`;
const getHabeasDataBySearching = (term) =>
  `${classificationServi}/habeas-data-classification?page=${
    term.page
  }&page_size=${term.page_size}&tipo_entidad=${
    term.tipo_entidad || ""
  }&producto_cod=${term.producto_cod || ""}&macro_motivo_cod=${
    term.macro_motivo_cod || ""
  }&codigo_queja=${term.codigo_queja || ""}&insta_recepcion=${
    term.insta_recepcion || ""
  }&start_date=${term.start_date || ""}&end_date=${
    term.end_date || ""
  }&tipo_id_cf=${term.tipo_id_cf || ""}&nombre_cf=${
    term.nombre_cf || ""
  }&apoderado_nombre=${term.apoderado_nombre || ""}&email_user=${
    term.email_user || ""
  }&check_habeas_data=${
    term.check_habeas_data === true || term.check_habeas_data === false
      ? term.check_habeas_data
      : ""
  }&search=${term.search || ""}&company_sfc_code=${
    term.company_sfc_code || ""
  }&tipo_analisis=${term.tipo_analisis || ""}&is_habeas_data_usuario=${
    term.is_habeas_data_usuario || ""
  }&numero_id_cf=${term.numero_id_cf || ""}&email_notification_user=${
    term.email_notification || ""
  }`;

const updateAnalisysType = (docId) => {
  return `${classificationServi}/update-analisys-type?doc_id=${docId}`;
};

// Gestión de solicitudes de Soporte técnico - peticiones.
const getSupport = (pagination, term) => {
  return `${baseUserTS}/?page=${pagination.page}&page_size=${
    pagination.pageSize
  }&name=${term.name || ""}&identification_type=${
    term.identification_type || ""
  }&identification_number=${term.identification_number || ""}&email=${
    term.email || ""
  }&phone=${term.phone || ""}&management_start=${
    term.management_start || ""
  }&management_end=${term.management_end || ""}&type_problem=${
    term.type_problem || ""
  }&status_cod=${term.status_cod || ""}&creation_end=${
    term.creation_end || ""
  }&creation_start=${term.creation_start || ""}`;
};

const getSupportById = (id) => {
  return `${baseUserTS}/${id}/`;
};

const getSupportDownload = (id) => {
  return `${baseUserTSDownLoad}/?id_support=${id}`;
};

const updateTechnicalSupport = (id) => {
  return `${baseUserTS}/${id}/`;
};

// Histórico de consumidores financieros - peticiones.

const getHistoricalConsum = (pagination, term) => {
  return `${baseHistoricalConsum}/?page=${pagination.page}&page_size=${
    pagination.pageSize
  }&tipo_id_CF=${term.tipo_id_CF || ""}&numero_id_CF=${
    term.numero_id_CF || ""
  }&email=${term.email || ""}&phone=${term.phone || ""}&name=${
    term.name || ""
  }&creation_start=${term.creation_start || ""}&creation_end=${
    term.creation_end || ""
  }`;
};

const getHistoricalConsumById = (id) => {
  return `${baseHistoricalConsum}/${id}/`;
};

const getHistoricalConsumDetail = (idUser, tipoCf) => {
  return `${baseHistoricalConsum}/${idUser}/?tipo_id_CF=${tipoCf}`;
};

// Servicios web para consumidores financieros|
const getCustomerComplaints = (pagination, term) => {
  return `${baseComplaints}/?page=${pagination.page}&page_size=${
    pagination.pageSize
  }&agiliza_estado_id=${term.estado_agiliza || ""}&codigo_queja=${
    term.codigo_queja || ""
  }&company__id=${term.entidad || ""}&estado_cod=${
    term.estado || ""
  }&is_queja_agiliza=${term.is_queja_agiliza || ""}&macro_motivo_cod__id=${
    term.motivo || ""
  }&agiliza_estado_sesion=${term.agiliza_estado_sesion || ""}&session_start=${
    term.session_start || ""
  }&session_end=${term.session_end || ""}`;
};

// Gestión de entidades emisoras de valores.
const baseCompanyEmisoresUrl = "/companyemisores_list";
const baseCompanyEmisoresMasivo = "/companyemisores/inactivations/";
const baseComplaintEmisores = "/emisores";
const baseAnexesComplaintEmisores = "/emisores-downloader";
const baseExportSolip = "/queries-servi/file/emisoresconsolidated-ac-link";
const baseRetrySolip = "/retry-solip-emisores";
const baseRetrySolipAnexes = "/retry-solip-annex-emisores";

const getCompanyEmisores = (pagination, data) => {
  return `${baseCompanyEmisoresUrl}/?page=${pagination.page}&page_size=${
    pagination.pageSize
  }&name=${data.name || ""}&nit=${data.nit || ""}&company_emisores_type=${
    data.company_emisores_type || ""
  }&code=${data.code || ""}&company_emisores_control=${
    data.company_emisores_control || ""
  }&is_active=${data.is_active}`;
};

const getCompanyEmisoresById = (id) => {
  return `${baseCompanyEmisoresUrl}/${id}/`;
};

const createCompanyEmisores = () => {
  return `${baseCompanyEmisoresUrl}/`;
};

const ActiveInactiveCompanyEmisores = (id) => {
  return `${baseCompanyEmisoresUrl}/${id}/`;
};

const updateCompanyEmisoresById = (id) => {
  return `${baseCompanyEmisoresUrl}/${id}/`;
};

const updateMassiveCompanyEmisores = () => {
  return `${baseCompanyEmisoresMasivo}`;
};

// Gestión de quejas de emisores de valores
const downloadComplaintEmisoresAnnexes = (id) => {
  return `${baseAnexesComplaintEmisores}/?id_storage=${id}`;
};

const getComplaintEmisorDetail = (id) => {
  return `${baseComplaintEmisores}/${id}/`;
};

const getComplaintEmisoresList = (pagination, data) => {
  return `${baseComplaintEmisores}/?page=${pagination.page}&page_size=${
    pagination.pageSize
  }&company_emisores_id=${
    data.company_emisores_id || ""
  }&motivo_emisores_id__tipo_valor_id=${
    data.motivo_emisores_id__tipo_valor_id || ""
  }&motivo_emisores_id=${data.motivo_emisores_id || ""}&codigo_queja=${
    data.codigo_queja || ""
  }&estado_solip=${data.estado_solip || ""}&estado_solip_anexes=${
    data.estado_solip_anexes || ""
  }&tipo_id_CF=${data.tipo_id_CF || ""}&numero_id_CF=${
    data.numero_id_CF || ""
  }&apoderado_nombre=${data.apoderado_nombre || ""}&apoderado_correo=${
    data.apoderado_correo || ""
  }&nombres=${data.nombres || ""}&email=${
    data.email || ""
  }&email_notification=${data.email_notification || ""}&start_date=${
    data.start_date || ""
  }&end_date=${data.end_date || ""}`;
};

const generateComplaintEmisoresInfoSolip = (typeExport, data) => {
  return `${baseExportSolip}?get_file=${typeExport}&company_emisores_id=${
    data.company_emisores_id || ""
  }&motivo_emisores_id__tipo_valor_id=${
    data.motivo_emisores_id__tipo_valor_id || ""
  }&motivo_emisores_id=${data.motivo_emisores_id || ""}&codigo_queja=${
    data.codigo_queja || ""
  }&estado_solip=${data.estado_solip || ""}&estado_solip_anexes=${
    data.estado_solip_anexes || ""
  }&tipo_id_CF=${data.tipo_id_CF || ""}&numero_id_CF=${
    data.numero_id_CF || ""
  }&apoderado_nombre=${data.apoderado_nombre || ""}&apoderado_correo=${
    data.apoderado_correo || ""
  }&nombres=${data.nombres || ""}&email=${
    data.email || ""
  }&email_notification=${data.email_notification || ""}&start_date=${
    data.start_date || ""
  }&end_date=${data.end_date || ""}`;
};

const retryFilingSolip = (codigoQueja) => {
  return `${baseRetrySolip}/?codigo_queja=${codigoQueja}`;
};

const retryFilingSolipAnexes = (codigoQueja, idAnexo) => {
  return `${baseRetrySolipAnexes}/?codigo_queja=${codigoQueja}&id_anexo=${idAnexo}`;
};

// Notificaciones consumidor financieron.
const baseCustomerNewNotify = "/alerts/cf_new_alerts";
const baseCustomerNotifyList = "/alerts/cf_history";
const baseMaskAsReadNotify = "/alerts/cf_mark_alert/";

const getNewNotificationsCustomer = (term, page_size) => {
  return `${baseCustomerNewNotify}/?viewed=${term.viewed}&page_size=${
    page_size || 10
  }`;
};

const getNotificationsCustomerList = (term, pagination) => {
  return `${baseCustomerNotifyList}/?start_date=${
    term?.start_date || ""
  }&end_date=${term?.end_date || ""}&viewed=${
    term?.viewed
  }&alert_cf_configuration__alert_cf_type__id=${
    term?.alert_cf_configuration__alert_cf_type__id || ""
  }&page_size=${pagination?.page_size || 5}&page=${pagination?.page || 1}`;
};

const setMaskAsReadNotify = () => {
  return `${baseMaskAsReadNotify}`;
};

// Notificaciones administrativo de la SFC.
const baseSfcNewNotify = "/alerts/sfc_new_alerts";
const baseSfcNotifyList = "/alerts/sfc_history";
const baseSfcMaskAsReadNotify = "/alerts/sfc_mark_alert";

const getNewNotificationsSfc = (term, page_size) => {
  return `${baseSfcNewNotify}/?user_sfc=${term?.user_sfc || ""}&viewed=${
    term.viewed
  }&page_size=${page_size || DEFAULT_NOTIFICATIONS_PAGE_SIZE}`;
};

const getNotificationsSfcList = (term, pagination) => {
  return `${baseSfcNotifyList}/?user_sfc=${term?.user_sfc || ""}&start_date=${
    term?.start_date || ""
  }&end_date=${term?.end_date || ""}&viewed=${
    term?.viewed
  }&alert_cf_configuration__alert_cf_type__id=${
    term?.alert_cf_configuration__alert_cf_type__id || ""
  }&page_size=${
    pagination?.page_size || DEFAULT_NOTIFICATIONS_PAGE_SIZE
  }&page=${pagination?.page || 1}`;
};

const setMaskAsReadNotifySfc = () => {
  return `${baseSfcMaskAsReadNotify}`;
};

// Servicios web para entidades vigiladas
const baseComplaintAgilizaList = "/agiliza-quejaall";
const baseComplaintGenerateReportAgilizaEv =
  "/queries-servi/file/generate_agiliza_report";

const getComplaintAgilizaList = (pagination, term, isGetCount) => {
  return `${baseComplaintAgilizaList}/?page=${
    pagination?.page || 1
  }&page_size=${pagination?.pageSize || 5}&start_date=${
    term?.start_date || ""
  }&end_date=${term?.end_date || ""}&codigo_queja=${
    term?.codigo_queja || ""
  }&macro_motivo_cod=${term?.motivo_agiliza_cod || ""}&tipo_id_CF=${
    term?.tipo_id_CF || ""
  }&numero_id_CF=${term?.numero_id_CF || ""}&estado_agiliza_id=${
    term?.estado_agiliza_id || ""
  }&agiliza_estado_sesion=${term.agiliza_estado_sesion || ""}&session_start=${
    term.session_start || ""
  }&session_end=${term.session_end || ""}${
    isGetCount ? "&get_count=true" : ""
  }`;
};

const generateReportAgilizaEv = (typeExport, term) => {
  return `${baseComplaintGenerateReportAgilizaEv}?get_file=${typeExport}&start_date=${
    term?.start_date || ""
  }&end_date=${term?.end_date || ""}&codigo_queja=${
    term?.codigo_queja || ""
  }&macro_motivo_cod=${term?.motivo_agiliza_cod || ""}&tipo_id_CF=${
    term?.tipo_id_CF || ""
  }&numero_id_CF=${term?.numero_id_CF || ""}&estado_agiliza_id=${
    term?.estado_agiliza_id || ""
  }`;
};

// Servicios web para procesos Agiliza
const baseUpdateComplaintAgilizaData = "/agiliza-update";
const updateComplaintAgilizaData = (codigoQueja) => {
  return `${baseUpdateComplaintAgilizaData}/${codigoQueja}/`;
};

// Descarga de anexos de quejas Agiliza
const baseDownloadComplaintAgilizaAnnexes = "/storage-agiliza-consult";
const downloadComplaintAgilizaAnnexes = (id) => {
  return `${baseDownloadComplaintAgilizaAnnexes}/url/?id_storage=${id}`;
};
 
// Clasficiación - Derechos dep eticion y Habeas data
const getClasificationSolipDpHd = (pagination, data) => {
  return `${classificationServi}/get_solip_dp_hd?page=${
    pagination.page
  }&page_size=${pagination.pageSize}&apoderado_nombre=${
    data.apoderado_nombre || ""
  }&apoderado_correo=${data.apoderado_correo || ""}&check_habeas_data=${
    data.check_habeas_data || ""
  }&codigo_queja=${data.codigo_queja || ""}&company_sfc_code=${
    data.company_sfc_code || ""
  }&email_user=${data.email_user || ""}&entidad_cod=${
    data.entidad_cod || ""
  }&estado_solip_id=${data.estado_solip_id || ""}&estado_solip_annexes_id=${
    data.estado_solip_annexes_id || ""
  }&insta_recepcion=${data.insta_recepcion || ""}&macro_motivo_cod=${
    data.macro_motivo_cod || ""
  }&nombre_cf=${data.nombre_cf || ""}&numero_id_cf=${
    data.numero_id_cf || ""
  }&producto_cod=${data.producto_cod || ""}&solicitud=${
    data.solicitud || ""
  }&tipo_id_cf=${data.tipo_id_cf || ""}&tipo_entidad=${
    data.tipo_entidad || ""
  }&start_date=${data.start_date || ""}&end_date=${data.end_date || ""}`;
};

const generateClasificationSolipDpHdInfoSolip = (typeExport, data) => {
  return `${classificationServi}/generate_solip_report?get_file=${typeExport}&apoderado_nombre=${
    data.apoderado_nombre || ""
  }&apoderado_correo=${data.apoderado_correo || ""}&check_habeas_data=${
    data.check_habeas_data || ""
  }&codigo_queja=${data.codigo_queja || ""}&company_sfc_code=${
    data.company_sfc_code || ""
  }&email_user=${data.email_user || ""}&entidad_cod=${
    data.entidad_cod || ""
  }&estado_solip_id=${data.estado_solip_id || ""}&estado_solip_annexes_id=${
    data.estado_solip_annexes_id || ""
  }&insta_recepcion=${data.insta_recepcion || ""}&macro_motivo_cod=${
    data.macro_motivo_cod || ""
  }&nombre_cf=${data.nombre_cf || ""}&numero_id_cf=${
    data.numero_id_cf || ""
  }&producto_cod=${data.producto_cod || ""}&solicitud=${
    data.solicitud || ""
  }&tipo_id_cf=${data.tipo_id_cf || ""}&tipo_entidad=${
    data.tipo_entidad || ""
  }&start_date=${data.start_date || ""}&end_date=${data.end_date || ""}`;
};

const retryClasificationSolipDpHd = (documentId) => {
  return `${classificationServi}/retry_solip_upload_dp_hd?doc_id=${documentId}`;
};

const retryClasificationSolipDpHdAnexes = () => {
  return `${classificationServi}/retry_solip_annex_upload_dp_hd`;
};

const getClasificationSolipDpHdDetail = (id) => {
  return `${classificationServi}/detail_solip_radication?doc_id=${id}`;
};

const downloadClasificationSolipDpHd = () => {
  return `${classificationServi}/download_dp_hd_annex`;
};

// Agiiza - Fase dos
const baseSetWorkingHours = "/auth-group-schedule";

const getWorkingHoursForFacilitators = (authGroupId) => {
  return `${baseSetWorkingHours}/${authGroupId}/`;
};
const setWorkingHoursForFacilitators = (authGroupId) => {
  return `${baseSetWorkingHours}/${authGroupId}/`;
};

const baseSetSessionDuration = "/session-duration";
const setSessionDuration = (sessionDurationId) => {
  return `${baseSetSessionDuration}/${sessionDurationId}/`;
};

const baseAgilizaFacilitators = "/agilizafacilitators";
const getAgilizaFacilitators = (pagination, data) => {
  return `${baseAgilizaFacilitators}/?page=${pagination.page}&page_size=${
    pagination.pageSize
  }&name=${data.name || ""}&identification_type=${
    data.identification_type || ""
  }&identification_number=${data.identification_number || ""}&email=${
    data.email || ""
  }&is_receiving_scheduling=${data.is_receiving_scheduling ?? ""}`;
};

const baseAgilizaFacilitatorState = "/facilitatorstate";
const updateAgilizaFacilitatorState = (uuid) => {
  return `${baseAgilizaFacilitatorState}/${uuid}/`;
};

const baseSessionsAgiliza = "/session-agiliza";
const getSessionsAgiliza = (pagination, data) => {
  return `${baseSessionsAgiliza}/?page=${pagination.page}&page_size=${
    pagination.pageSize
  }&entidad=${data.entidad || ""}&motivo_queja=${
    data.motivo_queja || ""
  }&codigo_queja=${data.codigo_queja || ""}&session_state_agiliza=${
    data.session_state_agiliza || ""
  }&sesion_start=${data.sesion_start || ""}&sesion_end=${
    data.sesion_end || ""
  }&creation_start=${data.creation_start || ""}&creation_end=${
    data.creation_end || ""
  }&identification_type=${
    data.identification_type || ""
  }&identification_number=${data.identification_number || ""}&name=${
    data.name || ""
  }&user_id_facilitator=${data.user_id_facilitator || ""}&email=${
    data.email || ""
  }`;
};

const baseAvailableSpacesAgiliza = "/session-slots/get-slots";
const getAvailableSpacesAgiliza = (uuid) => {
  return `${baseAvailableSpacesAgiliza}/${uuid}/`;
};

const baseSchedulesession = "/session-slots/schedule";
const scheduleSessionAgiliza = (uuid) => {
  return `${baseSchedulesession}/${uuid}/`;
};

const baseRescheduleSessionAgiliza = "/session-slots/reschedule";
const rescheduleSessionAgiliza = (uuid) => {
  return `${baseRescheduleSessionAgiliza}/${uuid}/`;
};

export default {
  updateAnualReport,
  getCounters,
  createAnualReport,
  getAnualReport,
  listAnualReports,
  updateAnualReportFiles,
  deleteAnualReportFiles,
  getReports,
  getReport,
  multifilterReport,
  manageReport,
  getClassifition,
  getClassifitionBySearching,
  getRetrieveUserCompressions,
  getRetrieveAnnexes,
  cancelCompressJob,
  uploadFIlesReport,
  getHabeasData,
  getHabeasDataBySearching,
  getReportClassition,
  updateAnalisysType,
  getSupport,
  getSupportById,
  getSupportDownload,
  updateTechnicalSupport,
  getHistoricalConsum,
  getHistoricalConsumById,
  getHistoricalConsumDetail,
  getCustomerComplaints,
  getCompanyEmisores,
  getCompanyEmisoresById,
  createCompanyEmisores,
  updateCompanyEmisoresById,
  ActiveInactiveCompanyEmisores,
  updateMassiveCompanyEmisores,
  getComplaintEmisoresList,
  generateComplaintEmisoresInfoSolip,
  retryFilingSolip,
  getComplaintEmisorDetail,
  downloadComplaintEmisoresAnnexes,
  retryFilingSolipAnexes,
  getNewNotificationsCustomer,
  getNotificationsCustomerList,
  setMaskAsReadNotify,
  getComplaintAgilizaList,
  generateReportAgilizaEv,
  updateComplaintAgilizaData,
  downloadComplaintAgilizaAnnexes,
  getClasificationSolipDpHd,
  generateClasificationSolipDpHdInfoSolip,
  retryClasificationSolipDpHd,
  retryClasificationSolipDpHdAnexes,
  getClasificationSolipDpHdDetail,
  downloadClasificationSolipDpHd,
  getRetrieveUserCompressions,
  getRetrieveAnnexes,  
  getWorkingHoursForFacilitators,
  setWorkingHoursForFacilitators,
  setSessionDuration,
  getAgilizaFacilitators,
  updateAgilizaFacilitatorState,
  getSessionsAgiliza,
  getAvailableSpacesAgiliza,
  rescheduleSessionAgiliza,
  scheduleSessionAgiliza,
  getNewNotificationsSfc,
  getNotificationsSfcList,
  setMaskAsReadNotifySfc,
};
